import * as React from "react";
import { useLazyLoadImage } from "@/Utilities";
import { SvgImagePattern, SvgShadowFilter } from "./SvgTemplateDefs";

function HalfpageTemplateSVG({ src, id, ...props }) {

  const uniqueId = 'hf_' + id;
  const imageRef = useLazyLoadImage(src);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return (
    <svg
      width="100%"
      height="360"
      viewBox="0 0 466 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g filter={`url(#filter0_d_${uniqueId})`}>
        <g clipPath={`url(#clip0_${uniqueId})`}>
          <rect
            x={30.9768}
            y={32.6498}
            width={404.046}
            height={307.614}
            rx={3.61832}
            fill="white"
          />
          <path
            d="M41.8347 43.8072H46.6592"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.8347 45.918H46.6592"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.8347 48.0286H46.6592"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.3735 47.5759L61.7304 48.9327"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.1279 45.6167C61.1279 44.1179 59.913 42.903 58.4142 42.903C56.9154 42.903 55.7004 44.1179 55.7004 45.6167C55.7004 47.1155 56.9154 48.3304 58.4142 48.3304C59.913 48.3304 61.1279 47.1155 61.1279 45.6167Z"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinejoin="round"
          />
          <path
            d="M224.983 48.8713V42.8749H225.925V48.0147H227.476V48.8713H224.983Z"
            fill="#1D1D1D"
          />
          <path
            d="M223.584 42.8745L224.543 48.8708H223.592L223.429 47.7829H222.273L222.11 48.8708H221.245L222.205 42.8745H223.584ZM222.847 43.9367L222.393 46.9691H223.301L222.847 43.9367Z"
            fill="#1D1D1D"
          />
          <path
            d="M220.031 46.636H220.922V47.4327C220.922 48.3921 220.442 48.9403 219.517 48.9403C218.592 48.9403 218.112 48.3921 218.112 47.4327V44.3146C218.112 43.3552 218.592 42.8069 219.517 42.8069C220.442 42.8069 220.922 43.3552 220.922 44.3146V44.8971H220.031V44.2546C220.031 43.8263 219.842 43.6636 219.542 43.6636C219.243 43.6636 219.054 43.8263 219.054 44.2546V47.4926C219.054 47.921 219.243 48.0752 219.542 48.0752C219.842 48.0752 220.031 47.921 220.031 47.4926V46.636Z"
            fill="#1D1D1D"
          />
          <path
            d="M215.655 44.2546V47.4926C215.655 47.921 215.844 48.0837 216.144 48.0837C216.444 48.0837 216.632 47.921 216.632 47.4926V44.2546C216.632 43.8263 216.444 43.6636 216.144 43.6636C215.844 43.6636 215.655 43.8263 215.655 44.2546ZM214.713 47.4327V44.3146C214.713 43.3552 215.219 42.8069 216.144 42.8069C217.069 42.8069 217.574 43.3552 217.574 44.3146V47.4327C217.574 48.3921 217.069 48.9403 216.144 48.9403C215.219 48.9403 214.713 48.3921 214.713 47.4327Z"
            fill="#1D1D1D"
          />
          <path
            d="M211.89 48.8719V42.8755H212.832V48.0153H214.382V48.8719H211.89Z"
            fill="#1D1D1D"
          />
          <path
            d="M249.43 45.0168C249.43 44.4489 249.709 44.1244 250.252 44.1244C250.794 44.1244 251.073 44.4489 251.073 45.0168V45.1284H250.546V44.9813C250.546 44.7278 250.445 44.6314 250.267 44.6314C250.09 44.6314 249.988 44.7278 249.988 44.9813C249.988 45.7115 251.078 45.8484 251.078 46.8625C251.078 47.4304 250.794 47.7549 250.247 47.7549C249.699 47.7549 249.415 47.4304 249.415 46.8625V46.6445H249.943V46.898C249.943 47.1515 250.054 47.2428 250.232 47.2428C250.409 47.2428 250.521 47.1515 250.521 46.898C250.521 46.1678 249.43 46.0309 249.43 45.0168Z"
            fill="#1D1D1D"
          />
          <path
            d="M244.592 47.6738L244.389 45.7825L244.187 47.6738H243.421L243.025 44.1244H243.568L243.867 46.9234L244.136 44.1244H244.673L244.952 46.9436L245.241 44.1244H245.728L245.333 47.6738H244.592Z"
            fill="#1D1D1D"
          />
          <path
            d="M238.109 44.6318V45.6205H238.874V46.1276H238.109V47.1671H239.072V47.6741H237.551V44.1247H239.072V44.6318H238.109Z"
            fill="#1D1D1D"
          />
          <path
            d="M232.764 47.6741L232.069 45.1033V47.6741H231.567V44.1247H232.267L232.84 46.2493V44.1247H233.337V47.6741H232.764Z"
            fill="#1D1D1D"
          />
          <path
            d="M250.865 42.2994H248.03H246.931H241.892H240.793H235.759H234.656H231.825C230.004 42.2994 228.522 43.7812 228.522 45.6022V46.2334C228.522 48.0543 230.004 49.5361 231.825 49.5361H234.656H235.759H240.794H241.892H246.932H248.03H250.866C252.687 49.5361 254.168 48.0543 254.168 46.2334V45.6022C254.168 43.781 252.687 42.2994 250.865 42.2994ZM234.656 48.4327H231.825C230.612 48.4327 229.625 47.4461 229.625 46.2332V45.602C229.625 44.389 230.612 43.4024 231.825 43.4024H234.656V48.4327ZM240.789 48.4327H235.759V43.4026H240.789V48.4327ZM246.927 48.4327H241.897V43.4026H246.927V48.4327ZM253.065 46.2332C253.065 47.4461 252.078 48.4327 250.865 48.4327H248.035V43.4026H250.865C252.078 43.4026 253.065 44.3892 253.065 45.6022V46.2332Z"
            fill="#1D1D1D"
          />
          <path
            d="M420.118 46.9673C419.691 47.2213 418.572 47.74 419.254 48.389C419.586 48.706 419.957 48.9328 420.423 48.9328H423.082C423.548 48.9328 423.919 48.706 424.251 48.389C424.933 47.74 423.814 47.2213 423.388 46.9673C422.387 46.3717 421.118 46.3717 420.118 46.9673Z"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M423.115 44.2588C423.115 45.0082 422.508 45.6157 421.758 45.6157C421.009 45.6157 420.402 45.0082 420.402 44.2588C420.402 43.5095 421.009 42.902 421.758 42.902C422.508 42.902 423.115 43.5095 423.115 44.2588Z"
            stroke="#1D1D1D"
            strokeWidth={0.603054}
          />
          <rect
            x={43.0391}
            y={129.215}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0388}
            y={141.879}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0388}
            y={154.543}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0388}
            y={167.207}
            width={190.565}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={191.857}
            width={232.176}
            height={45.2532}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={240.728}
            width={150.763}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={254.574}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={267.238}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={279.903}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={292.567}
            width={192.595}
            height={9.15838}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={317.336}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={44.2429}
            y={330}
            width={232.176}
            height={9.04581}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={43.0388}
            y={59.3169}
            width={74.9797}
            height={54.2749}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={121.637}
            y={59.3168}
            width={74.9797}
            height={54.2749}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={200.235}
            y={59.3168}
            width={74.9797}
            height={54.2749}
            rx={1.20611}
            fill="#F0F0F0"
          />
          <rect
            x={287.411}
            y={59.3168}
            width={135.687}
            height={271.374}
            fill={`url(#pattern0_${uniqueId})`}
          />
        </g>
      </g>
      <g filter={`url(#filter1_d_${uniqueId})`}>
        <g clipPath={`url(#clip1_${uniqueId})`}>
          <rect
            x={63.3005}
            y={156.557}
            width={107.476}
            height={232.461}
            rx={3.23237}
            fill="white"
          />
          <g clipPath={`url(#clip2_${uniqueId})`}>
            <path
              opacity={0.35}
              d="M159.742 162.289C159.742 161.946 160.02 161.668 160.363 161.668H165.14C165.483 161.668 165.761 161.946 165.761 162.289V164.009C165.761 164.352 165.483 164.63 165.14 164.63H160.363C160.02 164.63 159.742 164.352 159.742 164.009V162.289Z"
              stroke="black"
              strokeWidth={0.286603}
            />
            <path
              opacity={0.4}
              d="M166.191 162.576V163.722C166.422 163.625 166.572 163.399 166.572 163.149C166.572 162.899 166.422 162.673 166.191 162.576Z"
              fill="black"
            />
            <path
              d="M160.173 162.48C160.173 162.269 160.344 162.098 160.555 162.098H164.949C165.16 162.098 165.331 162.269 165.331 162.48V163.818C165.331 164.029 165.16 164.2 164.949 164.2H160.555C160.344 164.2 160.173 164.029 160.173 163.818V162.48Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M155.968 162.177C156.603 162.177 157.214 162.421 157.674 162.858C157.709 162.892 157.764 162.892 157.798 162.857L158.13 162.523C158.147 162.506 158.157 162.482 158.156 162.458C158.156 162.433 158.146 162.41 158.129 162.392C156.921 161.235 155.015 161.235 153.807 162.392C153.789 162.41 153.779 162.433 153.779 162.458C153.779 162.482 153.789 162.506 153.806 162.523L154.137 162.857C154.172 162.892 154.227 162.892 154.262 162.858C154.722 162.421 155.333 162.177 155.968 162.177ZM155.968 163.265C156.317 163.265 156.653 163.394 156.912 163.629C156.947 163.662 157.002 163.661 157.036 163.627L157.367 163.293C157.384 163.275 157.394 163.251 157.394 163.226C157.394 163.202 157.383 163.178 157.366 163.161C156.578 162.428 155.358 162.428 154.571 163.161C154.553 163.178 154.543 163.202 154.542 163.227C154.542 163.251 154.552 163.275 154.569 163.293L154.9 163.627C154.934 163.661 154.989 163.662 155.024 163.629C155.283 163.394 155.619 163.265 155.968 163.265ZM156.631 163.997C156.631 164.021 156.621 164.045 156.604 164.063L156.031 164.64C156.015 164.657 155.992 164.667 155.968 164.667C155.944 164.667 155.921 164.657 155.904 164.64L155.332 164.063C155.314 164.045 155.304 164.021 155.305 163.997C155.305 163.972 155.316 163.948 155.334 163.932C155.7 163.622 156.235 163.622 156.601 163.932C156.619 163.948 156.63 163.972 156.631 163.997Z"
              fill="black"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M152.052 161.62H151.765C151.607 161.62 151.479 161.749 151.479 161.907V164.391C151.479 164.549 151.607 164.677 151.765 164.677H152.052C152.21 164.677 152.339 164.549 152.339 164.391V161.907C152.339 161.749 152.21 161.62 152.052 161.62ZM150.428 162.289H150.714C150.873 162.289 151.001 162.417 151.001 162.576V164.391C151.001 164.549 150.873 164.677 150.714 164.677H150.428C150.27 164.677 150.141 164.549 150.141 164.391V162.576C150.141 162.417 150.27 162.289 150.428 162.289ZM149.377 162.958H149.09C148.932 162.958 148.804 163.086 148.804 163.244V164.391C148.804 164.549 148.932 164.677 149.09 164.677H149.377C149.535 164.677 149.664 164.549 149.664 164.391V163.244C149.664 163.086 149.535 162.958 149.377 162.958ZM148.04 163.531H147.753C147.595 163.531 147.466 163.659 147.466 163.818V164.391C147.466 164.549 147.595 164.678 147.753 164.678H148.04C148.198 164.678 148.326 164.549 148.326 164.391V163.818C148.326 163.659 148.198 163.531 148.04 163.531Z"
              fill="black"
            />
            <path
              d="M73.9963 164.655C74.7667 164.655 75.2243 164.053 75.2243 163.033C75.2243 162.649 75.1508 162.325 75.0102 162.076C74.8066 161.687 74.456 161.477 74.0131 161.477C73.354 161.477 72.8879 161.92 72.8879 162.542C72.8879 163.125 73.3078 163.549 73.885 163.549C74.2398 163.549 74.5274 163.383 74.6701 163.096H74.6764C74.6764 163.096 74.6848 163.096 74.6869 163.096C74.6911 163.096 74.7058 163.096 74.7058 163.096C74.7058 163.788 74.4434 164.202 74.0005 164.202C73.7402 164.202 73.5387 164.059 73.4694 163.83H72.9299C73.0202 164.328 73.4421 164.655 73.9963 164.655ZM74.0152 163.119C73.6667 163.119 73.419 162.871 73.419 162.525C73.419 162.187 73.6793 161.929 74.0173 161.929C74.3552 161.929 74.6155 162.191 74.6155 162.533C74.6155 162.871 74.3615 163.119 74.0152 163.119Z"
              fill="black"
            />
            <path
              d="M76.1102 164.626C76.3096 164.626 76.4461 164.483 76.4461 164.294C76.4461 164.103 76.3096 163.963 76.1102 163.963C75.9129 163.963 75.7743 164.103 75.7743 164.294C75.7743 164.483 75.9129 164.626 76.1102 164.626ZM76.1102 163.052C76.3096 163.052 76.4461 162.911 76.4461 162.722C76.4461 162.531 76.3096 162.39 76.1102 162.39C75.9129 162.39 75.7743 162.531 75.7743 162.722C75.7743 162.911 75.9129 163.052 76.1102 163.052Z"
              fill="black"
            />
            <path
              d="M78.411 164.582H78.9295V164.017H79.3388V163.56H78.9295V161.553H78.1654C77.6301 162.359 77.204 163.033 76.9311 163.534V164.017H78.411V164.582ZM77.4328 163.541C77.7854 162.919 78.1003 162.422 78.39 161.994H78.4194V163.572H77.4328V163.541Z"
              fill="black"
            />
            <path
              d="M80.4934 164.582H81.035V161.553H80.4955L79.7041 162.107V162.628L80.4577 162.099H80.4934V164.582Z"
              fill="black"
            />
            <rect
              x={97.979}
              y={385.292}
              width={38.4049}
              height={1.43302}
              rx={0.716509}
              fill="black"
            />
          </g>
          <rect
            x={63.4351}
            y={167.871}
            width={107.476}
            height={214.953}
            fill={`url(#pattern1_${uniqueId})`}
          />
        </g>
        <rect
          x={63.4352}
          y={156.692}
          width={107.207}
          height={232.192}
          rx={3.09769}
          stroke="#EDEDED"
          strokeWidth={0.269364}
        />
      </g>
      <defs>
        <SvgShadowFilter id={"filter0_d_" + uniqueId} uniqueId={uniqueId} x={6.85464} y={12.1459} width={452.29} height={355.858}
          radius={6.03054} dy={3.61832} blur={9.04581} />
        <SvgImagePattern id={"pattern0_" + uniqueId} uniqueId={uniqueId} transform="scale(0.000833333 0.000416667)" />
        <SvgShadowFilter id={"filter1_d_" + uniqueId} uniqueId={uniqueId} x={41.7514} y={138.24} width={150.575} height={275.56}
          radius={5.38728} dy={3.23237} blur={8.08092} composite />
        <SvgImagePattern id={"pattern1_" + uniqueId} uniqueId={uniqueId} transform="scale(0.000833333 0.000416667)" />
        <clipPath id={"clip0_"+ uniqueId}>
          <rect
            x={30.9768}
            y={32.6498}
            width={404.046}
            height={307.614}
            rx={3.61832}
            fill="white"
          />
        </clipPath>
        <clipPath id={"clip1_"+ uniqueId}>
          <rect
            x={63.3005}
            y={156.557}
            width={107.476}
            height={232.461}
            rx={3.23237}
            fill="white"
          />
        </clipPath>
        <clipPath id={"clip2_" + uniqueId}>
          <rect
            width={107.476}
            height={232.453}
            fill="white"
            transform="translate(63.3003 156.557)"
          />
        </clipPath>
        <image
          id={"image0_" + uniqueId}
          ref={imageRef}
          width={1200}
          height={2400}
          href={isSafari ? src : ''}
          loading="lazy"
        />
      </defs>
    </svg>
  );
}
export const SvgTemplateHalfpage = React.memo(HalfpageTemplateSVG);